import React, { Fragment, useRef } from "react";
import { useForm } from "react-hook-form";
import {
    Row,
    Col,
    Form,
    Button
} from "reactstrap";
import ReactDOM from "react-dom";
import CanvasDraw from "react-canvas-draw";

const VehicleDamage = ({ setSteps, setFormdata, formdata }) => {
    const { handleSubmit } = useForm();
    let canvasRef = React.useRef();;

    const onSubmit = () => {
        const damage_declaration = canvasRef.current.getSaveData();
        setFormdata((prev) => ({ ...prev, damage_declaration }));
        setSteps((prev) => prev + 1);
    };

    const onBack = () => {
        setSteps((prev) => prev - 1);
    };

    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                        <div className="dflex">
                            <Col md="12 mb-6">
                                <CanvasDraw
                                    ref={canvasRef}
                                    canvasWidth={800}
                                    brushColor="rgba(155,12,60,0.3)"
                                    imgSrc={`${process.env.REACT_APP_PUBLIC_URL}/${formdata.car_type}.png`}
                                />
                            </Col>
                            <div className="text-end btn-mb">
                                <Button type="submit" className="primary">Siguiente</Button>
                                <Button type="button" className="primary" onClick={onBack}>Anterior</Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default VehicleDamage;
